import "../../styles/about.css";

import React from "react";

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
}

const TextInput: React.FC<ButtonProps> = ({
  onClick,
  children,
  isLoading,
  ...rest
}) => {
  return (
    <>
      <button className="plush-button" onClick={onClick} {...rest}>
        {isLoading ? "loading..." : children}
      </button>
      <style jsx>{`
        .plush-button {
          width: 100%;
          background: #191919;
          color: #ffffff;
          padding: 12px 16px;
          display: flex;
          align-items: center;
          justify-content: center;

          text-align: center;
          font-size: 14px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          letter-spacing: -0.28px;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
          font-smooth: never;
        }
      `}</style>
    </>
  );
};

export default TextInput;
